import { render, staticRenderFns } from "./AuthorNameAndCreationTime.vue?vue&type=template&id=3df470cc&scoped=true"
import script from "./AuthorNameAndCreationTime.vue?vue&type=script&lang=js"
export * from "./AuthorNameAndCreationTime.vue?vue&type=script&lang=js"
import style0 from "./AuthorNameAndCreationTime.vue?vue&type=style&index=0&id=3df470cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df470cc",
  null
  
)

export default component.exports